function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "396.598 239.816 18.841 22.274",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 410.001 250.708 L 411.401 250.708 C 411.732 250.708 412.001 250.977 412.001 251.308 L 412.001 258.108 C 412.001 258.439 411.732 258.708 411.401 258.708 L 400.601 258.708 C 400.269 258.708 400.001 258.439 400.001 258.108 L 400.001 251.308 C 400.001 250.977 400.269 250.708 400.601 250.708 L 402.001 250.708 L 410.001 250.708 Z M 410.001 250.708 L 410.001 246.708 C 410.001 245.375 409.201 242.708 406.001 242.708 C 402.801 242.708 402.001 245.375 402.001 246.708 L 402.001 250.708 L 410.001 250.708 Z M 410.001 250.708 L 402.001 250.708 L 410.001 250.708 Z",
    style: {
      fill: "none",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 410.001 250.708 L 402.001 250.708 M 410.001 250.708 L 411.401 250.708 C 411.732 250.708 412.001 250.977 412.001 251.308 L 412.001 258.108 C 412.001 258.439 411.732 258.708 411.401 258.708 L 400.601 258.708 C 400.269 258.708 400.001 258.439 400.001 258.108 L 400.001 251.308 C 400.001 250.977 400.269 250.708 400.601 250.708 L 402.001 250.708 L 410.001 250.708 Z M 410.001 250.708 L 410.001 246.708 C 410.001 245.375 409.201 242.708 406.001 242.708 C 402.801 242.708 402.001 245.375 402.001 246.708 L 402.001 250.708 L 410.001 250.708 Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#21272A",
    style: {
      fill: "none",
      fillRule: "evenodd",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.598,
    y: 239.816,
    width: 18.841,
    height: 22.274,
    style: {
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.319850c6306117b0d0df71fdbfc85382.svg";
export { ForwardRef as ReactComponent };